'use client';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import { UiKitButtonBack } from '@/fo/ui/kit/button/back';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitInputBase } from '@/fo/ui/kit/input/base';
import { useForm } from '@/fo/ui/mod/form/base';
import { utilEventAuthModal } from '@/fo/util/event-auth-modal';

import { styles } from './FeatureAuthFormForgotPassword.styles';
import { formAction } from './formAction';

export function FeatureAuthFormForgotPassword() {
  const slots = styles();
  const t = useTranslations();
  const { action, getFieldProps, pending, state } = useForm(formAction);

  useEffect(() => {
    const hasEmailValidationError = Boolean(state.errors?.email);

    if (!pending && state.data?.email && !hasEmailValidationError) {
      utilEventAuthModal.showLogin(state.data.email as string);
    }
  }, [state, pending]);

  return (
    <div className={slots.base()}>
      <UiKitButtonBack
        onClick={() => utilEventAuthModal.showLogin()}
        className={slots.backButton()}
      />
      <div>
        <h3 className={slots.title()}>{t('form.forgotPassword.title')}</h3>
        <p className={slots.description()}>
          {t('form.forgotPassword.description')}
        </p>

        <form action={action}>
          <UiKitInputBase
            label={t('form.label.email')}
            type="email"
            {...getFieldProps('email')}
            disabled={pending}
          />

          <UiKitButtonBase
            type="submit"
            className={slots.button()}
            loading={pending}
          >
            {t('Send')}
          </UiKitButtonBase>
        </form>
      </div>
    </div>
  );
}
